import React from 'react';
import { hashCode } from './String';
import GeoFenceMarker from './GeoFenceMarker';
import useMap from './useMap';
import { Palette } from './Palette';
const createGeoFence = (container, map) => new google.maps.Polygon({
    paths: container.area
        ?.at(0)
        ?.slice(0, -1) // Hide the last one which should be the same as the first one.
        ?.map((e) => ({ lat: e[1], lng: e[0] })),
    geodesic: true,
    strokeColor: Palette.GeoFence,
    strokeOpacity: 1.0,
    strokeWeight: 3,
    fillColor: Palette.GeoFence,
    fillOpacity: 0.25,
    map,
});
function useGeoFences(geoFences, hideAreaCenter, draggable, onDragEnd) {
    const { map } = useMap();
    const ref = React.useRef(new Map());
    const [refreshKey, setRefreshKey] = React.useState();
    const shapes = React.useRef(new Map());
    React.useEffect(() => {
        if (!map) {
            return;
        }
        const oldKeys = new Set([...shapes.current.keys()]);
        const newKeys = new Map(geoFences?.map((e) => [hashCode(JSON.stringify(e || '')), e]) || []);
        let updated = false;
        [...oldKeys]
            .filter((e) => !newKeys.has(e) && shapes.current.has(e))
            .forEach((e) => {
            ref.current.delete(e);
            shapes.current?.get(e)?.setMap(null);
            shapes.current?.delete(e);
            updated = true;
        });
        [...newKeys.entries()]
            .filter((e) => !oldKeys.has(e[0]) || !shapes.current.has(e[0]))
            .forEach((e) => {
            const key = e[0];
            const object = e[1];
            if ((object?.area?.at(0)?.length || 0) < 2) {
                return;
            }
            ref.current.set(key, object);
            const newObject = createGeoFence(object, map);
            shapes.current.set(key, newObject);
            updated = true;
        });
        if (updated) {
            setRefreshKey(Math.random());
        }
    }, [geoFences, shapes, ref, map]);
    const markers = React.useMemo(() => hideAreaCenter
        ? []
        : [...ref.current.values()]?.map((geoFence, index) => {
            // Hide the last one which should be the same as the first one.
            const points = geoFence.area?.at(0)?.slice(0, -1);
            if (!points) {
                return undefined;
            }
            const lat = points.reduce((prev, curr) => prev + curr[1], 0) / points.length;
            const lng = points.reduce((prev, curr) => prev + curr[0], 0) / points.length;
            return (React.createElement(GeoFenceMarker, { key: index, position: { lat, lng }, draggable: draggable, onDragEnd: onDragEnd ? (coords) => onDragEnd(index.toString(), coords) : undefined, title: "Geo Fence", geoFenceId: geoFence.id }));
        }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ref, refreshKey, draggable, onDragEnd, hideAreaCenter]);
    return { markers };
}
export default useGeoFences;
